export default function Footer() {
  return (
    <footer
      className="border-t border-[var(--border)] bg-white mt-12"
      data-testid="app-footer"
    >
      {/* Accent tick band — small editorial punctuation at the very top */}
      <div className="relative">
        <div className="hair-tick" />
      </div>
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-12 md:py-14 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <img
            src="/decal-lab-logo.v558587.png"
            alt="Decal Labs"
            className="h-10 w-auto select-none mb-2"
            draggable="false"
          />
          <p className="text-[var(--fg-2)] mt-3 leading-relaxed">
            Vector conversion tooling tuned for racing-game livery editors with
            strict decal SVG specifications.
          </p>
          <a
            href="mailto:support@decallabs.co.za"
            className="prose-link block mt-3 text-sm"
            data-testid="footer-support-email"
          >
            support@decallabs.co.za
          </a>
          <div className="mt-4 flex gap-2 flex-wrap">
            <span className="chip">
              <span className="status-dot ok"></span>
              ALL SYSTEMS GO
            </span>
          </div>
        </div>
        <div>
          <div className="micro-label mb-3 accent-rule">Tools</div>
          <ul className="space-y-2">
            <li><a href="/convert" className="prose-link">Converter</a></li>
            <li><a href="/repair" className="prose-link">SVG Repair</a></li>
            <li><a href="/split" className="prose-link">Decal Splitter</a></li>
            <li><a href="/bulk" className="prose-link">Bulk upload</a></li>
            <li><a href="/how-to" className="prose-link">How to use</a></li>
          </ul>
        </div>
        <div>
          <div className="micro-label mb-3 accent-rule">Specs</div>
          <ul className="space-y-2 font-mono text-xs text-[var(--fg-2)]">
            <li className="flex items-center gap-2">
              <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
              MAX FILE 15KB
            </li>
            <li className="flex items-center gap-2">
              <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
              MAX PATHS ~1000
            </li>
            <li className="flex items-center gap-2">
              <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
              NO RASTER / SCRIPTS / FILTERS
            </li>
            <li className="flex items-center gap-2">
              <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
              FLAT RGB · NO ALPHA
            </li>
          </ul>
        </div>
        <div>
          <div className="micro-label mb-3 accent-rule">Quick Links</div>
          <ul className="space-y-2">
            <li><a href="/pricing" className="prose-link">Pricing</a></li>
            <li><a href="/contact" className="prose-link">Contact Us</a></li>
            <li><a href="/faqs" className="prose-link">FAQs</a></li>
            <li><a href="/terms" className="prose-link">Terms &amp; Conditions</a></li>
            <li><a href="/privacy" className="prose-link">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--border)] py-5 px-6 flex flex-wrap items-center justify-between gap-3 font-mono text-[10px] text-[var(--fg-2)] tracking-widest">
        <span data-testid="footer-copyright">
          © {new Date().getFullYear()} DECAL LABS — PRECISION VECTORIZATION
        </span>
        <a
          href="https://silentlogic.solutions"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 hover:text-[var(--accent)] transition-colors"
          data-testid="footer-silent-logic"
          aria-label="Product of Silent Logic — opens in a new tab"
        >
          <span>PRODUCT OF SILENT LOGIC</span>
          <img
            src="/silent-logic-logo.v26b7f3.png"
            alt="Silent Logic"
            className="h-5 w-auto select-none opacity-80 hover:opacity-100 transition-opacity"
            draggable="false"
          />
        </a>
        <span className="flex items-center gap-3">
          <a href="/terms" className="hover:text-[var(--accent)]">TERMS &amp; CONDITIONS</a>
          <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
          <a href="/privacy" className="hover:text-[var(--accent)]">PRIVACY POLICY</a>
          <span className="h-1 w-1 bg-[var(--accent)] inline-block" />
          <span>BASED IN SOUTH AFRICA</span>
        </span>
      </div>
    </footer>
  );
}
